import React from "react";
import { useWarehouseContext } from "./WarehouseProvider";
import { WeightCapture } from "./components/WeightCapture";
import conformWeightIcon from "./images/conform-weight-icon.png";

const TITLE = "Weight Conform";

export const ConformingWeightCapture = () => {
  const { conformingWeight, setConformingWeight } = useWarehouseContext();

  return (
    <WeightCapture
      title={TITLE}
      instruction={
        <div className="flex flex-col gap-10">
          <div>
            Transfer all conform material into the control container
            <br /> and record the weight.
          </div>
          <div className="bg-[#060E23] border border-[#282F44] rounded-xl px-4 py-3 mb-3 text-center">
            <span className="font-mono text-lg leading-tight uppercase text-white">
              ⚖️ WEIGH: CONTROL CONTAINER + conform
            </span>
          </div>
        </div>
      }
      icon={conformWeightIcon}
      iconAlt="Conform Weight"
      value={conformingWeight}
      onChange={setConformingWeight}
    />
  );
};

ConformingWeightCapture.title = TITLE;
